// ⭐ Zona horaria Ecuador (UTC-5, sin horario de verano) — fuente única.
//
// Antes CocinaDisplay.js, PedidosPendientes.js y ReportesUnificado.js tenían
// cada uno su propia copia IDÉNTICA de este cálculo, y MesasManager.js tenía
// una tercera implementación ligeramente distinta (parseo forzado a UTC +
// Intl con timeZone explícito) — 4 copias del mismo concepto en pantallas
// que además se referencian entre sí (mismo pedido, mismo código, visto
// desde 4 lugares) es justo el tipo de duplicación que puede desalinearse
// sin que nadie lo note. Esta es la única fuente ahora.
//
// SQLite guarda DATETIME('now') como 'YYYY-MM-DD HH:MM:SS' naive UTC (sin
// sufijo de zona). El truco de "restar 5 horas y luego llamar a
// .getDay()/.toLocaleTimeString() sin especificar zona" solo da el resultado
// correcto si el dispositivo donde corre el navegador está configurado en
// hora de Ecuador — eso ya era así en las 3 copias mayoritarias antes de
// esta unificación (documentado como deuda conocida y aceptada del
// proyecto) y no se cambia acá: se unifica la implementación, no se
// reescribe el algoritmo ni se intenta "corregir" ese supuesto de fondo.

export function toEcuadorTime(dateStr) {
  if (!dateStr) return new Date();
  const utc = new Date(dateStr);
  return new Date(utc.getTime() - 5 * 60 * 60 * 1000);
}

export function formatEcuadorTime(dateStr, opts = {}) {
  const d = toEcuadorTime(dateStr);
  return d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', ...opts });
}

export function formatEcuadorDate(dateStr, opts = {}) {
  const d = toEcuadorTime(dateStr);
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', ...opts });
}

export function getEcuadorDateStr(dateStr) {
  const d = toEcuadorTime(dateStr);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Código único de pedido por día (L1, L2, M3...): letra del día de la
// semana + day_order_number, que YA calcula el backend sobre TODAS las
// ventas del día no anuladas (ver GET /api/pos/sales, /sales/unassigned,
// /tables, /kitchen, etc.) — nunca recalcular esto contando sobre un array
// parcial del lado del cliente, porque ese array puede no tener todas las
// ventas del día (filtros, paginación, LIMIT del backend) y desalinearse
// del código que muestran las otras pantallas para el mismo pedido.
export const DAY_PREFIXES = ['D', 'L', 'M', 'Ms', 'J', 'V', 'S'];

export function getOrderCode(order) {
  if (!order) return '';
  if (!order.day_order_number || !order.created_at) return `#${order.id}`;
  const dayOfWeek = toEcuadorTime(order.created_at).getDay();
  return `${DAY_PREFIXES[dayOfWeek]}${order.day_order_number}`;
}
